module.exports = __webpack_public_path__ + "static/philipp-46fe50d70e0c4d467c6bba5bf95e3e43.jpg";